export const PASSWORD_RESET = 'app/Features/public/ResetPassword/PASSWORD_RESET';